import { jsx } from '@emotion/react/jsx-runtime';
import { useTheme } from '@emotion/react';
import { createPolymorphicComponent } from '@nettbureau/core';
import { BaseTransition } from './base-transition.js';

/**
 * Map of enter transition values for each direction.
 */ const enterTransitions = {
    top: {
        clipPath: 'inset(0 0 0% 0)'
    },
    right: {
        clipPath: 'inset(0 0% 0 0)'
    },
    bottom: {
        clipPath: 'inset(0% 0 0 0)'
    },
    left: {
        clipPath: 'inset(0 0 0% 0)'
    }
};
/**
 * Map of exit transition values for each direction.
 */ const exitTransitions = {
    top: {
        clipPath: 'inset(100% 0 0 0)'
    },
    right: {
        clipPath: 'inset(0 100% 0 0)'
    },
    bottom: {
        clipPath: 'inset(0 0 100% 0)'
    },
    left: {
        clipPath: 'inset(0 0 0 100%)'
    }
};
/**
 * A component that reveals its children in and out based on the `visible` prop.
 */ const RevealInOut = createPolymorphicComponent(({ direction = 'right', duration = 'fast', in: visible, initial, ...elementProps }, ref)=>{
    const theme = useTheme();
    const transition = {
        duration: typeof duration === 'number' ? duration : theme.motionDurations[duration],
        ease: theme.motionTimings.standard
    };
    const enter = {
        ...enterTransitions[direction],
        transitionEnd: {
            clipPath: 'none'
        },
        transition
    };
    const exit = {
        ...exitTransitions[direction],
        transition
    };
    return /*#__PURE__*/ jsx(BaseTransition, {
        ...elementProps,
        ref: ref,
        enter: enter,
        exit: exit,
        initial: initial,
        mounted: visible,
        children: elementProps.children
    });
});

export { RevealInOut };
//# sourceMappingURL=reveal-in-out.js.map
